import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import Header from "../../components/Header";
import { BreadcrumbBox } from "../../components/common/Breadcrumb";
import PopularCourse from "./components/PopularCourse";
import CourseTag from "./components/CourseTag";
import Footer from "../../components/Footer";
import { Styles } from "./styles/course.js";
import { Constant, imageDomain } from "../../helper/Constants.js";
import axios from "axios";
import { Link } from "react-router-dom";

function CourseDetails() {
  const [course, setCourse] = useState(null);
  const [related, setRelated] = useState([]);
  const [loading, setLoading] = useState(true);
  const [relLoading, setRelLoading] = useState(true);
  const [error, setError] = useState(null);
  const [id, setId] = useState("")
  const [courseId, setCourseId] = useState(null);


  // helper: get id from URL (last segment)
  const getIdFromPath = () => {
    try {
      const parts = window.location.pathname.split("/").filter(Boolean);
      setId(parts[parts.length - 1])
      return parts[parts.length - 1];
    } catch (e) {
      return null;
    }
  };

  // helper: build image url (uses imageDomain if available)
  const buildImageUrl = (img, fallback = "/assets/images/details-banner.jpg") => {
    if (!img) return process.env.PUBLIC_URL + fallback;
    if (/^https?:\/\//i.test(img)) return img;
    if (imageDomain)
      return imageDomain.replace(/\/$/, "") + (img.startsWith("/") ? "" : "/") + img;
    return (process.env.PUBLIC_URL || "") + (img.startsWith("/") ? img : "/" + img);
  };

useEffect(() => {
  const getIdFromPath = () => {
    const parts = window.location.pathname.split("/").filter(Boolean);
    return parts[parts.length - 1];
  };

  setCourseId(getIdFromPath());
}, [window.location.pathname]);

  useEffect(() => {
     getIdFromPath();
    // if (!id) {
    //   setError("Course id not found in URL.");
    //   setLoading(false);
    //   return;
    // }

    const fetchCourse = async () => {
      setLoading(true);
      setError(null);
      try {
        // try to build URL from Constants, fallback to getAllCourses + id
        let courseUrl = (Constant.getUrls && (Constant.getUrls.getCourse || Constant.getUrls.getCourseById || Constant.getUrls.getAllCourses)) || null;
        if (courseUrl && courseUrl.includes(":id")) courseUrl = courseUrl.replace(":id", courseId);
        else if (courseUrl && !courseUrl.includes(":id") && courseUrl === Constant.getUrls.getAllCourses) courseUrl = Constant.getUrls.getAllCourses + "/" + courseId;
        else if (!courseUrl) courseUrl = `/api/courses/${courseId}`;

        const resp = await axios.get(courseUrl);
        const payload = resp?.data?.data ?? resp?.data ?? null;
        const courseData = payload?.data ?? payload ?? null;

        if (!courseData) {
          setError("Course data not found.");
          setCourse(null);
        } else {
          setCourse(courseData);
        }
      } catch (err) {
        console.error("Failed to fetch course:", err);
        setError(err?.response?.data?.message || err.message || "Failed to fetch course");
      } finally {
        setLoading(false);
      }
    };

    fetchCourse();
  }, [courseId]);

  // fetch related courses (first 5 excluding current)
  useEffect(() => {
    const id = getIdFromPath();
    const getRelated = async () => {
      setRelLoading(true);
      try {
        const url = Constant.getUrls.getAllCourses || "/api/courses";
        const resp = await axios.get(url);
        const payload = resp?.data?.data?.docs ?? resp?.data?.data ?? resp?.data ?? [];
        const list = Array.isArray(payload) ? payload : Array.isArray(payload.docs) ? payload.docs : [];
        // exclude current and take first 5
        const filtered = list.filter((c) => String(c._id) !== String(id)).slice(0, 5);
        setRelated(filtered);
      } catch (err) {
        console.error("Failed to fetch related courses:", err);
        setRelated([]);
      } finally {
        setRelLoading(false);
      }
    };

    getRelated();
  }, [course]); // run after course load so we can exclude current

  // safe getters
  const title = course?.course_name || course?.title || "Untitled Course";
  const authorName = course?.author?.name || course?.authorName || "Author";
  const authorImg = course?.author?.image || "/assets/images/author.jpg";
  const category = course?.category || course?.course_type?.toUpperCase() || "Uncategorized";
  const rating = course?.rating ?? 0;
  const price = course?.price ?? course?.course_price ?? "Free";
  const banner = course?.banner || course?.image || course?.course_banner || "";
  const descriptionHTML = course?.description || course?.course_description || "";

  return (
    <div className="main-wrapper course-details-page">
      {/* Header */}
      <Header />

      {/* Breadcrumb */}
      <BreadcrumbBox title="Course Details" />

      <Styles>
        <section className="course-details-area">
          <Container>
            <Row>
              {/* Main column: only description */}
              <Col lg="9" md="8" sm="12">
                <div className="course-details-top">
                  <div className="heading">
                    <h4>{title}</h4>
                  </div>

                  <div className="course-top-overview">
                    <div className="d-flex overviews">
                      <div className="author">
                        {/* <img src={buildImageUrl(authorImg)} alt={authorName} /> */}
                        <div className="author-name">
                          <h6>Author</h6>
                          <p>{authorName}</p>
                        </div>
                      </div>

                      <div className="category">
                        <h6>Category</h6>
                        <p>{category}</p>
                      </div>

                      <div className="rating">
                        <h6>Rating</h6>
                        <ul className="list-unstyled list-inline">
                          {Array.from({ length: 5 }).map((_, i) => {
                            const full = i < Math.floor(rating);
                            const half = !full && rating - Math.floor(rating) >= 0.5;
                            return (
                              <li key={i} className="list-inline-item">
                                {full ? <i className="las la-star" /> : half ? <i className="las la-star-half-alt" /> : <i className="las la-star" />}
                              </li>
                            );
                          })}
                          <li className="list-inline-item">({rating})</li>
                        </ul>
                      </div>

                      <div className="price">
                        <h6>Price</h6>
                        <p>{typeof price === "number" ? `₹ ${price}` : price}</p>
                      </div>
                    </div>
                  </div>

                  <div className="course-details-banner">
                    <img src={buildImageUrl(banner)} alt={title} className="img-fluid" />
                  </div>

                  {/* ONLY DESCRIPTION — no curriculum / instructor / review tabs */}
                  <div className="course-desc">
                    <h5>Course Description</h5>
                    {loading ? (
                      <p>Loading...</p>
                    ) : error ? (
                      <p style={{ color: "red" }}>{error}</p>
                    ) : (
                      <div dangerouslySetInnerHTML={{ __html: descriptionHTML || "<p>No description provided.</p>" }} />
                    )}
                  </div>
                </div>
              </Col>

              {/* Right column: side menu of 5 courses */}
              <Col lg="3" md="4" sm="12">
                <div className="single-details-sidbar">
                  <Row>
                    {/* <Col md="12">
                      <div className="course-details-feature">
                        <h5 className="title">Other Courses</h5>

                        {relLoading ? (
                          <p>Loading...</p>
                        ) : related.length === 0 ? (
                          <p>No other courses found.</p>
                        ) : (
                          <ul className="list-unstyled related-courses">
                            {related.map((c) => {
                              const cLink = c.slug ? `/course/${c.slug}` : `/course/${c._id}`;
                              const cImg = c.image || c.banner || c.course_banner || "";
                              return (
                                <li key={c._id} style={{ marginBottom: 12 }}>
                                  <Link to={process.env.PUBLIC_URL + cLink} style={{ display: "flex", gap: 12, alignItems: "center", textDecoration: "none", color: "inherit" }}>
                                    <img src={buildImageUrl(cImg, "/assets/images/default-course.jpg")} alt={c.course_name || c.title} style={{ width: 70, height: 50, objectFit: "cover", borderRadius: 6 }} />
                                    <div>
                                      <div style={{ fontSize: 14, fontWeight: 600 }}>{c.course_name || c.title || "Untitled"}</div>
                                      <div style={{ fontSize: 12, color: "#666" }}>{typeof c.price === "number" ? `₹ ${c.price}` : (c.price || "Free")}</div>
                                    </div>
                                  </Link>
                                </li>
                              );
                            })}
                          </ul>
                        )}
                      </div>
                    </Col> */}

                    <Col md="12">
                      {/* Optionally keep PopularCourse or CourseTag below the list */}
                      <PopularCourse />
                    </Col>

                    {/* <Col md="12">
                      <CourseTag />
                    </Col> */}
                  </Row>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
      </Styles>

      <Footer />
    </div>
  );
}

export default CourseDetails;
